module.exports = __webpack_public_path__ + "img/snack-time.d384df0f.svg";